import { render, staticRenderFns } from "./SiteLogoBS46.vue?vue&type=template&id=63ede6bb&scoped=true"
import script from "./SiteLogoBS46.vue?vue&type=script&lang=js"
export * from "./SiteLogoBS46.vue?vue&type=script&lang=js"
import style0 from "./SiteLogoBS46.vue?vue&type=style&index=0&id=63ede6bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ede6bb",
  null
  
)

export default component.exports